/**
 * Checks if defined project property is not null or is not empty
 */
export function isValidProperty(obj: Record<string, unknown>, property: keyof typeof obj) {
  if (property in obj) {
    return obj[property] != null && obj[property] !== '';
  }

  return false;
}
